import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { usePageTitle } from '../Utilities/usePageTitle';

export default function NotFound() {
  usePageTitle('דף לא נמצא');
  const location = useLocation();

  return (
    <div style={{ padding: 24, textAlign: 'center' }}>
      <h1>העמוד שביקשת לא נמצא</h1>
      <p>העמוד <strong>{location.pathname}</strong> אינו קיים.</p>

      <div style={{ marginTop: 16 }}>
        <Link to="/" className="btn btn-primary" style={{ margin: 20 }}>לדף הבית</Link>
        <button className="btn btn-secondary" onClick={() => window.location.reload()}>טען מחדש</button>
      </div>

      <details style={{ marginTop: 18, textAlign: 'left', display: 'inline-block', maxWidth: 800 }}>
        <summary>Debug info</summary>
        <pre style={{ whiteSpace: 'pre-wrap' }}>
href: {window.location.href}
pathname: {location.pathname}
search: {location.search}
hash: {location.hash}
        </pre>
      </details>
    </div>
  );
}
